"use strict";

var _taggedTemplateLiteral = require("/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 8px;\n  color: ", ";\n  background: ", ";\n  justify-content: center;\n  border-radius: 2px;\n  ", ";\n\n  &:hover:enabled {\n    color: ", ";\n    box-shadow: 0 0 0 3px ", ";\n  }\n  &:focus {\n    color: ", ";\n    box-shadow: 0 0 0 3px ", ";\n  }\n\n  &:active:enabled {\n    background: ", ";\n    box-shadow: 0 0 0 3px ", ";\n  }\n\n  &:not([data-focus-visible-added]):disabled {\n    cursor: not-allowed;\n    opacity: 0.6;\n    path {\n      stroke: ", ";\n    }\n  }\n\n  @media (min-width: ", "px) {\n    width: 535px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components"));

var Button_1 = require("./Button");

exports.PrimaryButton = styled_components_1.default(Button_1.Button)(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.black;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.bodyStyle3;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.black;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.focus;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.black;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.focus;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.focus;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.white;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.grid.breakpoints.md;
});